export default {"src":"https://images-cdn.curipod.com/d-e1df7c9c/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};